/**
 * Formatação sensível ao idioma ativo.
 *
 * Use estes helpers em vez de `toLocaleString('pt-BR')` ou de formatos de data
 * fixos — eles seguem o idioma escolhido pelo usuário.
 *
 * O que NÃO passa por aqui: máscaras de documento brasileiro (CPF, CNPJ, CEP,
 * telefone). São formatos de dado nacionais e não mudam com o idioma; só o label
 * e o placeholder desses campos são traduzidos.
 */
import { idiomaAtual } from './index';

/** Moeda por idioma. Valores em real continuam em real — muda a apresentação. */
const MOEDA_POR_IDIOMA = {
    'pt-BR': 'BRL',
    'en-US': 'BRL',
    'es': 'BRL',
};

const MOEDA_PADRAO = 'BRL';

export function formatarNumero(valor, opcoes = {}) {
    if (valor === null || valor === undefined || valor === '') {
        return '';
    }

    const numero = Number(valor);

    if (Number.isNaN(numero)) {
        return '';
    }

    return new Intl.NumberFormat(idiomaAtual(), opcoes).format(numero);
}

export function formatarMoeda(valor, opcoes = {}) {
    const idioma = idiomaAtual();

    return formatarNumero(valor, {
        style: 'currency',
        currency: MOEDA_POR_IDIOMA[idioma] || MOEDA_PADRAO,
        ...opcoes,
    });
}

export function formatarPercentual(valor, opcoes = {}) {
    return formatarNumero(valor, {
        style: 'percent',
        maximumFractionDigits: 2,
        ...opcoes,
    });
}

function paraData(valor) {
    if (!valor) {
        return null;
    }

    const data = valor instanceof Date ? valor : new Date(valor);

    return Number.isNaN(data.getTime()) ? null : data;
}

/** Data curta: 05/08/2026 em pt-BR, 8/5/2026 em en-US. */
export function formatarData(valor, opcoes = {}) {
    const data = paraData(valor);

    if (!data) {
        return '';
    }

    return new Intl.DateTimeFormat(idiomaAtual(), {
        dateStyle: 'short',
        ...opcoes,
    }).format(data);
}

export function formatarDataHora(valor, opcoes = {}) {
    const data = paraData(valor);

    if (!data) {
        return '';
    }

    return new Intl.DateTimeFormat(idiomaAtual(), {
        dateStyle: 'short',
        timeStyle: 'short',
        ...opcoes,
    }).format(data);
}

export function formatarHora(valor, opcoes = {}) {
    const data = paraData(valor);

    if (!data) {
        return '';
    }

    return new Intl.DateTimeFormat(idiomaAtual(), {
        timeStyle: 'short',
        ...opcoes,
    }).format(data);
}
